<div class="item_card_wrap">
    <div class="card_con">
        <img src="assets/imgs/glasses_icon.png" alt="안경 아이콘">
        <div class="text_box">
            <span>스마트 안경</span>
        </div>
    </div>
</div>